import { NavLink, useParams } from 'react-router-dom';
import {
  AdjustmentsHorizontalIcon,
  ClockIcon,
  TagIcon,
  CalendarIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { useManagerContext } from '../../../layouts/ManagerLayout';
import ChainItrs from '../../../components/ChainItrs';
import NotFound from '../../NotFound';
import Wrapper from '../../../components/Wrapper';
import EditChain from './EditChain';

export default function Chain() {
  const { idChain } = useParams();
  const { t } = useTranslation();
  const [editChainOpen, setEditChainOpen] = useState(false);
  const {
    allChains: { chains, itrs },
  } = useManagerContext();
  const chain = chains[Number(idChain)];
  if (!chain) {
    return (
      <NotFound
        text="Chain not found"
        description="The chain you are looking for does not exist."
      />
    );
  }
  return (
    <Wrapper>
      {editChainOpen && (
        <EditChain
          open={editChainOpen}
          setOpen={setEditChainOpen}
          chain={chain}
        />
      )}
      <div className="rounded-lg bg-white shadow-md p-4 my-2">
        <h3 className="text-center text-md text-xl font-bold h-full text-gray-900">
          {chain.chain_name}
        </h3>
      </div>
      <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <ChainItrs chain={chain} itrs={itrs} />
        <div className="col-span-1 flex flex-col gap-4">
          <NavLink
            to="labels"
            className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <TagIcon className="w-12 h-12 text-teal-500 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900">
              {t('manager.chains.labelControl')}
            </h3>
          </NavLink>
          <NavLink
            to="counters"
            className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <ClockIcon className="w-12 h-12 text-teal-500 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900">
              {t('manager.chains.countersControl')}
            </h3>
          </NavLink>
          {/* <NavLink
            to="holidays"
            className="flex flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <CalendarIcon className="w-12 h-12 text-teal-500 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900">
              {t('manager.chains.holidayControl')}
            </h3>
          </NavLink> */}
          <button
            onClick={() => setEditChainOpen(true)}
            className="flex w-full flex-col items-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <AdjustmentsHorizontalIcon className="w-12 h-12 text-teal-500 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900">
              {t('manager.chains.editChain')}
            </h3>
          </button>
        </div>
      </ul>
    </Wrapper>
  );
}
